export default "__VITE_ASSET__BAvpUpDv__"